import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/theme';
import { NotificationItem as NotificationType } from '@/services/universe/types';

import { formatNotificationTime } from '@/utils/date';

interface NotificationItemProps {
    item: NotificationType;
    onPress: (item: NotificationType) => void;
    onDelete?: (id: string) => void;
    showDelete?: boolean;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({ 
    item, 
    onPress, 
    onDelete, 
    showDelete = true
}) => {
    return (
        <TouchableOpacity 
            style={[
                styles.notificationItem, 
                !item.read_at && styles.unreadItem
            ]}
            activeOpacity={0.7}
            onPress={() => onPress(item)}
        >
            <View style={styles.iconContainer}>
                <Image
                    source={require('@/assets/images/Blue-Logo.png')}
                    style={styles.icon}
                    resizeMode="contain"
                />
            </View>
            <View style={styles.contentContainer}>
                <View style={styles.titleRow}>
                    <Text style={styles.title} numberOfLines={2}>{item.title}</Text>
                    <Text style={styles.time}>{formatNotificationTime(item.created_at)}</Text>
                </View>
                <Text style={styles.description} numberOfLines={2}>{item.body}</Text>
            </View>
            {showDelete && onDelete && (
                <TouchableOpacity 
                    onPress={(e) => {
                        e.stopPropagation();
                        onDelete(item.id);
                    }} 
                    style={styles.deleteButton}
                >
                    <Ionicons name="trash" size={18} color="#EF4444" />
                </TouchableOpacity>
            )}
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    notificationItem: {
        flexDirection: 'row',
        padding: 16,
        backgroundColor: 'white',
        alignItems: 'center',
    },
    unreadItem: {
        backgroundColor: '#F0F7FF',
    },
    iconContainer: {
        width: 48,
        height: 48,
        backgroundColor: Colors.brand,
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 12,
    },
    icon: {
        width: 40,
        height: 40,
    },
    contentContainer: {
        flex: 1,
    },
    titleRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 4,
    },
    title: {
        fontSize: 15,
        fontWeight: '700',
        color: '#1F2937',
        flex: 1,
        marginRight: 8,
    },
    time: {
        fontSize: 11,
        color: '#9CA3AF',
    },
    description: {
        fontSize: 13,
        color: '#4B5563',
        lineHeight: 18,
    },
    deleteButton: {
        padding: 8,
        marginLeft: 8,
    },
});
